import React, { useEffect, useState } from "react";
import campaignImg3 from "../../assets/images/campaign-3.jpg";
import campaignImg1 from "../../assets/images/campaign1.jpeg";
import campaignImg2 from "../../assets/images/campaign2.jpeg";
import LatestNews from "../../components/letestNews/LatestNews";
import Pagination from "../../components/pagination/Pagination";
import "./causes.css";

const data = [
  {
    id: 1,
    image: campaignImg1,
    tag: "Children",
    btnTitle: "Donate Now",
    subtitle: "Assisting Underprivileged and Talented Students with Admissions",
    content:
      " We always prioritize education, we assist excellent but economically needy students from different countries, including Bangladesh, Laos, Tanzania, and so on, to ensure that they have opportunities for higher study in either their country or China. In the past, hundreds of students have been assisted by the Malisha Foundation",
    percentage: "35",
    Ralsed: "$5,000",
  },
  {
    id: 2,
    image: campaignImg2,
    tag: "Children",
    btnTitle: "Donate Now",
    subtitle: "Distribution of Study Materials to Underprivileged Communities",
    content:
      "We at the Malisha Foundation are proud to support students' academic journeys by providing essential educational tools. Committed to empowering learners, we aim to remove barriers to education and help students excel in their studies. We are trying to create a positive learning environment where every student can thrive and reach their full potential.",
    percentage: "67",
    Ralsed: "$5,000",
  },
  {
    id: 3,
    image: campaignImg3,
    tag: "Children",
    btnTitle: "Donate Now",
    subtitle: "Aid for Underprivileged Communities During Natural Disasters",
    content:
      "We provide aid to underprivileged communities during natural disasters, delivering essential resources like food, water, and medical supplies. Partnering with local organizations, we help these communities rebuild and recover, ensuring long-term stability and resilience",
    percentage: "80",
    Ralsed: "$5,000",
  },
];

const Causes = () => {
  const [helpData, setHelpData] = useState([...data]);

  const breadCrumbArray = [
    {
      id: 1,
      title: "Home",
      link: "/",
      active: false,
    },
    {
      id: 2,
      title: "Activities",
      link: "/activities ",
      active: true,
    },
  ];

  useEffect(() => {
    document.title = "Activities";
  }, []);

  let renderView = null;
  renderView = helpData.map((item) => (
    <div key={item.id} className="relative campaign_cause_single">
      <div className="absolute top-2 left-2 bg-primary-container text-center py-2 px-4">
        <h5 className="text-on-primary-container text-base font-bold m-0 break-words">
          {item.tag}
        </h5>
      </div>
      <div className="relative">
        <img
          className="h-80 object-cover w-full roun rounded-t-md"
          src={item.image}
          alt="dfd"
        />
        {/* <div className="campaign_cause_single_btn bg-tertiary-container text-center py-3">
          <Link
            to="#"
            className="text-on-tertiary-container text-lg sm:text-base font-bold m-0 break-words"
          >
            {item.btnTitle}
          </Link>
        </div> */}
      </div>
      <div className="bg-white z-1 relative">
        <h4 className="text-gray-800 pt-6 lg:text-2xl md:text-xl text-lg font-bold m-0 break-words">
          {item.subtitle}
        </h4>
        <p className="pt-4 leading-7 font-normal text-lg m-0 break-words text-gray-700">
          {item.content}
        </p>
        {/* <ProgressLise percentageColor="text-gray-800" height='h-3' percentage={item.percentage} /> */}
      </div>
      {/* <div className='flex justify-between pt-4'>
        <h5 className="text-gray-700 text-base font-bold m-0 break-words">{`Ralsed: ${item.Ralsed}`} </h5>
        <h5 className="text-gray-700 text-base font-bold m-0 break-words">{`Ralsed: ${item.Ralsed}`} </h5>
      </div> */}
    </div>
  ));

  return (
    <div className="cause">
      {/* <BreadCrumb title="Activities" breadCrumbArray={breadCrumbArray} /> */}
      <div className="py-12 sm:py-20">
        <div className="container mt-10 max-w-2xl mx-auto px-4 text-center">
          {/* <h4 className="pb-2 text-primary font-bold text-sm m-0 break-words uppercase tracking-widest">
            OUR CAMPAIGNS
          </h4> */}
          <h2 className="pb-4 text-gray-900 text-xl lg:text-5xl md:text-3xl font-bold m-0 break-words">
            Our Highest Ambition is to Assist People
          </h2>
          <p className="pb-12 leading-7 font-normal text-lg text-white m-0 break-words text-gray-800">
            Helping hand for hoping heart
          </p>
        </div>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 gap-10 md:gap-6">
            {renderView}
          </div>
        </div>
        <Pagination />
      </div>
      {/* <BecomeYoutuber /> */}
      {/* <Feature /> */}
      <LatestNews />
    </div>
  );
};

export default Causes;
